<template>
  <div>
    <div class="search-material-steps container mt-5 overflow-hidden">
      <transition-group name="home-search" tag="div" class="row position-relative">
        <div v-if="!isEmptyObject(selectedProductCategory) && !isMobile()" key="tg-10">
          <div class="search-buttons">
            <div class="button mr-4" @click="goBack">
              <img src="@/assets/icons/step_back.svg" />
              <span v-html="$t('common.stepBack')"></span>
            </div>
            <div class="button" @click="reset">
              <img src="@/assets/icons/new_search.svg"  class="mr-1"/>
              <span v-html="$t('common.newSearch')"></span>
            </div>
          </div>
        </div>
        <div v-show="Object.keys(selectedProductCategory).length === 0 || isMobile()"
             class="col-md-8 home-search-item"
             key="tg-1">
          <div class="container">
            <div class="row">
              <div id="search-box" class="col-12 col-md-9">
                <header class="search-header">
                  <h2 class="text-lg mb-1" v-html="$t('stepsView.searchProduct')"></h2>
                  <p class="text-sm text-secondary">{{$t('stepsView.byNameTextOrNumber')}}</p>
                </header>
                <div class="pt-2 mb-3">
                  <SearchForm :forNavbar="false"/>
                </div>
                <img src="@/assets/search-image.jpg" class="img-fluid">
              </div>
              <div class="col-12 col-md-2">
                <div class="or-column">
                  <p class="text-secondary text-sm">{{$t('stepsView.or')}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="product-category" class="col-12 col-md-4 home-search-item" key="tg-2">
          <header class="search-header d-flex justify-content-between flex-column flex-xl-row">
            <div class="mr-2">
              <h2 class="text-lg mb-1" v-html="$t('stepsView.selectProduct')"></h2>
              <p class="text-sm text-secondary">{{$t('stepsView.byProductCategory')}}</p>
            </div>
          </header>
          <div class="step product-category">
            <div class="step__header">
              <div class="step__header--number">
                01
              </div>
              <div class="step__header--description" v-html="$t('stepsView.selectProductCategory')">
              </div>
            </div>
            <div class="step__content">
              <div class="text-center py-5" v-if="productCategoriesLoading">
                <b-spinner type="grow" variant="secondary"></b-spinner>
              </div>
              <template v-else>
                <div v-if="productCategoriesError">
                  <Error :msg="productCategoriesError" />
                </div>
                <ul v-else-if="productCategories.length" class="product-categories">
                  <li v-for="productCategory in productCategories"
                      :key="productCategory.id"
                      @click="selectedProductCategory.id != productCategory.id ? selectProductCategory(productCategory) : false"
                      :class="{
                        selected: selectedProductCategory.id === productCategory.id,
                        customBg: productCategory.acf.highlight_color,
                      }"
                      :style="{
                        backgroundColor: (productCategory.acf.highlight_color && selectedProductCategory.id === productCategory.id)
                          ? productCategory.acf.highlight_color : '#F5F5F5'
                      }">
                    <div class="text-uppercase">
                      <span class="bold">
                        {{productCategory.acf.short_name}}
                      </span> <span v-html="productCategory.name"></span>
                    </div>
                    <div>
                      <img src="@/assets/icons/arrow.svg"
                          v-if="selectedProductCategory.id === productCategory.id">
                      <img src="@/assets/icons/plus-secondary-thin.svg" v-else>
                    </div>
                  </li>
                </ul>
                <div v-else>
                  <NoContent :msg="$t('common.noContent')"/>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div id="product-group" class="col-12 col-md-4 mb-4 home-search-item"
             :class="{'d-md-none': Object.keys(selectedProductCategory).length === 0}"
             key="tg-3">
          <div class="search-header-placeholder"></div>
          <div v-if="Object.keys(selectedProductCategory).length != 0"
              class="step product-group">
            <div class="step__header">
              <div class="step__header--number">
                02
              </div>
              <div class="step__header--description" v-html="$t('stepsView.selectProductGroup')">
              </div>
            </div>
            <div class="step__content">
              <div class="text-center py-5" v-if="productGroupsLoading">
                <b-spinner type="grow" variant="secondary"></b-spinner>
              </div>
              <template v-else>
                <div v-if="productGroupsError">
                  <Error :msg="productGroupsError" />
                </div>
                <div v-else-if="productGroups.length" class="product-groups text-uppercase">
                  <div v-for="group in productGroups" :key="group.id"
                    class="group-item d-flex flex-column align-items-center justify-content-between"
                    @click="selectedProductGroup.id != group.id ? selectProductGroup(group) : false"
                    :class="{
                      selected: selectedProductGroup.id === group.id,
                      customBg: selectedProductCategory.acf.highlight_color
                    }"
                    :style="{
                      backgroundColor: (selectedProductCategory.acf.highlight_color && selectedProductGroup.id === group.id)
                        ? selectedProductCategory.acf.highlight_color : '#F5F5F5'
                    }">
                    <img :src="group.acf.image.url" class="img-fluid">
                    <span>{{group.name}}</span>
                  </div>
                </div>
                <div v-else>
                  <NoContent :msg="$t('common.noMatchingGroups')"/>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div id="material-type" class="col-12 col-md-4 step material home-search-item"
             key="tg-4">
          <div class="search-header-placeholder"></div>
          <div v-if="Object.keys(selectedProductCategory).length != 0 && Object.keys(selectedProductGroup).length != 0">
            <div class="step__header">
              <div class="step__header--number">
                03
              </div>
              <div class="step__header--description" v-html="$t('stepsView.selectMaterial')">
              </div>
            </div>
            <div class="step__content">
              <div class="text-center py-5" v-if="materialTypesLoading">
                <b-spinner type="grow" variant="secondary"></b-spinner>
              </div>
              <template v-else>
                <div v-if="materialTypesError">
                  <Error :msg="materialTypesError" />
                </div>
                <ul v-else-if="materialTypes.length" class="material-types">
                  <li v-for="materialType in materialTypes"
                      :key="materialType.id"
                      @click="selectMaterialType(materialType)"
                      :class="{
                        selected: selectedMaterialType.id === materialType.id
                      }">
                    <span>{{materialType.name}}</span>
                    <div>
                      <img src="@/assets/icons/arrow-secondary.svg"
                          v-if="selectedMaterialType.id === materialType.id">
                      <img src="@/assets/icons/plus-secondary-thin.svg" v-else>
                    </div>
                  </li>
                </ul>
                <div v-else>
                  <NoContent :msg="$t('common.noContent')"/>
                </div>
              </template>
            </div>
          </div>
        </div>
      </transition-group>
    </div>
    <section id="results" class="results container mt-5">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 col-xl-8">
          <div class="results-body" v-if="selectedMaterialType.id
                       && selectedProductCategory.id
                       && selectedProductGroup.id">
            <div class="results-breadcrumbs pb-2 mb-4 mb-xl-5">
              <p class="text-uppercase text-secondary m-0">
                {{$t('stepsView.resultsFor')}}
              </p>
              <div class="text-primary text-uppercase bold">
                {{selectedMaterialType.name}} >
                {{selectedProductCategory.acf.short_name}} <span v-html="selectedProductCategory.name"></span> >
                {{selectedProductGroup.name}}
              </div>
            </div>
            <div v-if="isHotlineTriggerPhrase(selectedProductGroup.name)" class="mb-4 mb-xl-5">
              <HotlineNumber :product="selectedProductGroup.name"/>
            </div>
            <div class="text-center" v-if="materialsLoading">
              <SearchItemSkeleton />
            </div>
            <template v-else>
              <div v-if="materialsError">
                <Error :msg="materialsError" />
              </div>
              <div v-else-if="materials.length">
                <div v-for="material in materials" :key="material.id"
                    class="mb-4">
                  <SearchItem :material="material"
                              :productCategory="selectedProductCategory"
                              :productGroup="selectedProductGroup"
                              :materialType="selectedMaterialType" />
                </div>
                <div id="materials-loading-more"
                    class="py-1">
                  <div v-if="materialsLoadingMore">
                    <div class="mb-4">
                      <SearchItemSkeleton />
                    </div>
                    <div class="mb-4">
                      <SearchItemSkeleton />
                    </div>
                  </div>
                </div>
                <div v-if="!materialsReachedTheEnd && !materialsLoadingMore" class="text-center">
                  <button class="btn btn-secondary btn-rounded mb-5 px-4 text-uppercase"
                          @click="getMaterials(true)">
                      {{$t('common.loadMore')}}
                  </button>
                </div>
              </div>
              <div v-else>
                <NoContent :msg="$t('common.noMaterials')"/>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import NoContent from '@/components/NoContent.vue';
import Error from '@/components/Error.vue';
import SearchItem from '@/components/SearchItem.vue';
import SearchItemSkeleton from '@/components/SearchItemSkeleton.vue';
import HotlineNumber from '@/components/HotlineNumber.vue';
import SearchForm from '@/components/SearchForm.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'SearchMaterialsWithSteps',
  components: {
    NoContent,
    Error,
    SearchItem,
    SearchItemSkeleton,
    HotlineNumber,
    SearchForm,
  },
  computed: {
    ...mapGetters({
      productCategories: 'threeSteps/productCategories',
      productCategoriesLoading: 'threeSteps/productCategoriesLoading',
      productCategoriesError: 'threeSteps/productCategoriesError',
      selectedProductCategory: 'threeSteps/selectedProductCategory',
      productGroups: 'threeSteps/productGroups',
      productGroupsLoading: 'threeSteps/productGroupsLoading',
      productGroupsError: 'threeSteps/productGroupsError',
      selectedProductGroup: 'threeSteps/selectedProductGroup',
      materialTypes: 'threeSteps/materialTypes',
      materialTypesLoading: 'threeSteps/materialTypesLoading',
      materialTypesError: 'threeSteps/materialTypesError',
      selectedMaterialType: 'threeSteps/selectedMaterialType',
      materials: 'threeSteps/materials',
      materialsLoading: 'threeSteps/materialsLoading',
      materialsLoadingMore: 'threeSteps/materialsLoadingMore',
      materialsCurrentPage: 'threeSteps/materialsCurrentPage',
      materialsTotalPages: 'threeSteps/materialsTotalPages',
      materialsReachedTheEnd: 'threeSteps/materialsReachedTheEnd',
      materialsError: 'threeSteps/materialsError',
    }),
  },
  methods: {
    selectProductCategory(category) {
      if (this.selectedProductGroup) this.$store.commit('threeSteps/clearProductGroups');
      if (this.selectedMaterialType) this.$store.commit('threeSteps/clearMaterialTypes');
      this.$store.commit('threeSteps/setSelectedProductCategory', category);
      this.$store.dispatch('threeSteps/getProductGroups');
      if (this.isMobile()) {
        this.$scrollTo('#product-group', 600, { offset: -30 });
      }
    },
    selectProductGroup(group) {
      this.$scrollTo('#material-type', 600, { offset: -30 });
      if (this.selectedProductGroup) this.$store.commit('threeSteps/clearMaterialTypes');
      this.$store.commit('threeSteps/setSelectedProductGroup', group);
      this.$store.dispatch('threeSteps/getMaterialTypes');
    },
    selectMaterialType(materialType) {
      this.$store.commit('threeSteps/setSelectedMaterialType', materialType);
      this.getMaterials();
    },
    getMaterials(loadingMore = false) {
      if (loadingMore) {
        this.$store.commit('threeSteps/setLoadingMore', loadingMore);
        this.$scrollTo('#materials-loading-more', 600, { offset: -50 });
      } else {
        this.$scrollTo('#results', 600, { offset: -30 });
      }
      this.$store.dispatch('threeSteps/getMaterials');
    },
    reset() {
      this.$store.dispatch('threeSteps/reset');
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  created() {
    if (!this.productCategories.length) {
      this.$store.dispatch('threeSteps/getProductCategories');
    }
  },
};
</script>

<style scoped lang="scss">
@import '@/assets/scss/common.scss';
.search-material-steps {
  .step {
    &__header {
      display: flex;
      align-items: center;
      margin-bottom: 1rem;
      &--number {
        color: $primary;
        font-size: 35px;
        margin-right: 10px;
      }
      &--description {
        color: $secondary;
        line-height: 1.1em;
        font-size: 12px;
      }
      @include media-breakpoint-down(lg) {
        &--number {
          font-size: 30px;
        }
        &--description {
          font-size: 10px;
        }
      }
    }
    &__content {
      font-size: 15px;
      @include media-breakpoint-down(lg) {
        font-size: 12px;
        .product-groups {
          img {
            max-width: 50px!important;
          }
        }
      }
    }
    ul.material-types {
      list-style-type: none;
      padding: 0;
      li {
        display: flex;
        justify-content: space-between;
        color: $primary;
        text-transform: uppercase;
        border-bottom: 1px solid $secondary;
        padding: .9em 1em;
        cursor: pointer;
        &:first-child {
          border-top: 1px solid $secondary;
        }
        img {
          width: 13px;
        }
        &.selected {
          font-weight: bold;
          cursor: default;
        }
      }
    }
    ul.product-categories {
      list-style-type: none;
      padding: 0;
      li {
        padding: .9em 1.3em;
        background-color: #F5F5F5;
        margin-bottom: 1.5em;
        color: $primary;
        border-radius: 7px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        cursor: pointer;
        &:not(.customBg) {
          &.selected {
            background-color: $secondary!important;
          }
        }
        img {
          width: 13px;
        }
        &.selected {
          background-color: $secondary;
          color: #fff;
          cursor: default;
        }
      }
    }
    @include media-breakpoint-down(sm) {
      ul.material-types,
      ul.product-categories {
        img {
          transform: rotate(90deg);
        }
      }
    }
    .product-groups {
      display: grid;
      grid-template-columns: 47% 47%;
      column-gap: 6%;
      row-gap: 20px;
      .group-item {
        background-color: #F5F5F5;
        padding: 25px 15px;
        border-radius: 7px;
        cursor: pointer;
        &.selected {
          background-color: $primary;
          cursor: default;
          span {
            color: #fff;
            font-weight: bold;
          }
          img {
            filter: $filter-to-white;
          }
        }
        &:not(.customBg) {
          &.selected {
            background-color: $secondary!important;
          }
        }
        img {
          max-width: 100px;
          margin-bottom: 1rem;
          filter: $filter-to-primary;
        }
        span {
          color: $primary;
          text-align: center;
        }
      }
    }
  }
}
.results {
  .results-breadcrumbs {
    border-bottom: 1px solid $secondary;
    p {
      font-size: 12px;
    }
    div {
      font-size: 14px;
    }
  }
  @include media-breakpoint-down(lg) {
    .results-breadcrumbs {
      p {
        font-size: 9px;
      }
      div {
        font-size: 10px;
      }
    }
  }
}

.home-search-item {
  transition: all .7s cubic-bezier(.63,.85,.55,.99);
}
.home-search-enter-from,
.home-search-leave-to {
  opacity: 0;
}
.home-search-enter-from {
  transform: translateY(400px);
}
.home-search-leave-to {
  transform: translateX(-150px);
}
.home-search-leave-active {
  position: absolute;
}

.or-column {
  text-align: center;
  height: 100%;
  p {
    display: inline-block;
    margin: 0 auto;
    position: relative;
    height: 100%;
    &::after {
      content: '';
      position: absolute;
      bottom: -25px;
      left: 50%;
      width: 1px;
      height: 100%;
      background-color: $primary;
    }
  }
  @include media-breakpoint-down(sm) {
    height: 100px;
    p {
      display: flex;
      justify-content: center;
      align-items: center;
      &::after,
      &::before {
        width: calc(50% - 10px);
        height: 1px;
        background-color: $primary;
      }
      &::before {
        content: '';
        position: absolute;
        right: -10px;
        top: 50%;
      }
      &::after {
        left: -10px;
        top: 50%;
      }
    }
  }
}

.search {
  &-buttons {
    position: absolute;
    top: 0; right: 30px;
    z-index: 2;
    display: flex;
    align-items: flex-start;
    justify-content: flex-end;
    .button {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      img {
        max-width: 30px;
      }
      span {
        font-size: 12px;
        line-height: 1.2em;
        color: $secondary;
      }
    }
    @include media-breakpoint-down(lg) {
      margin-bottom: 10px;
      span {
        font-size: 10px!important;
      }
    }
    @include media-breakpoint-down(sm) {
      display: none;
    }
  }
}

@include media-breakpoint-up(md) {
  .search-header,
  .search-header-placeholder {
    height: 95px;
  }
}
</style>
